import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 7 класс",
        subject: "Приёмы обучения нормам построения предложений с деепричастными оборотами",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Приёмы обучения нормам построения предложений с деепричастными оборотами",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Гостева Юлия Николаевна",
                grade: "старший научный сотрудник лаборатории филологического общего образования ФБГНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Предложения с деепричастными оборотами требуют особого внимания пишущего и говорящего. Правила их построения часто нарушаются в речи.</p>
                                </div>
                                 <div style='padding: 2.4rem;'>
                                    <p>Какие же трудности испытывают школьники при освоении нормы построения предложений с деепричастными оборотами?</p>
                                    <ul>
                                    <li>Большие затруднения возникают у обучающихся при опознавании деепричастного оборота в структуре предложения.</li>
                                    <li>Не могут правильно выделить грамматическую основу предложения, связать грамматически деепричастный оборот со сказуемым и субъектом действия.</li>
                                    <li>Не знают правил построения предложений с деепричастным оборотом.</li>
                                    <li>Не владеют приёмами конструирования предложений с деепричастными оборотами: приёмом синонимической замены, приёмом включения деепричастного оборота в структуру предложения с учётом смысловой и грамматической связи со сказуемым.</li>
                                    </ul>
                                    <p>Чтобы освоить нормы построения предложений с деепричастными оборотами, необходимо знать правила употребления деепричастий и деепричастных оборотов в предложении.</p>
                                    <br><p>Деепричастие, как правило, указывает на действие лица (субъекта), выраженного подлежащего, поэтому не должно употребляться в следующих случаях:</p>
                                    <ul>
                                    <li>Если действие, выраженное сказуемым, и действие, выраженное деепричастием, относятся к разным лицам, например: Возвращаясь домой, меня застиг дождь  (вместо: Когда я возвращался домой, меня застиг дождь.), </li>
                                    <li>Если в безличном предложении имеется логическое подлежащее (предмет мысли), например: Подходя к лесу, мне стало холодно  (вместо: Когда я подходил к лесу, мне стало холодно.); </li>
                                    <li>Если предложение выражено страдательной конструкцией, например: Получив тяжёлую контузию, лётчик был спасён партизанами (разные субъекты двух действий: действия, выраженного сказуемым, — партизаны, и действия, выраженного деепричастием, — летчик). Правильно построенное предложение звучит так: Лётчик получил тяжёлую контузию, но партизаны его спасли.</li>
                                    <li>Одной из распространённых ошибок является употребление деепричастий и глаголов как однородных членов предложения, соединённых союзом и: Сестра говорила взволнованно и от волнения роняя шарфик. Правильно построенное предложение звучит так: Сестра говорила взволнованно и от волнения роняла шарфик.</li>
                                    </ul>
                                    <p>А часто ли встречаются деепричастия в речи школьников?</p>
                                    <br><p>При изучении норм употребления деепричастий семиклассники вторгаются в малознакомую им область русского языка. Деепричастия сравнительно редко употребляются в разговорной речи, которая «на слуху» у ученика, однако широко используются в текстах научного стиля, в художественных текстах, представленных, например, в школьных учебниках.  </p>
                                    <br><p>Ребята должны постепенно привыкать к графическому облику деепричастий, знать правила употребления деепричастий и деепричастных оборотов в тексте. Элементы смыслового и языкового анализа научно-популярного и художественного текстов необходимо включать в структуру урока, так что работа по освоению современных норм употребления деепричастий важна не только для достижения результатов обучения по русскому языку, но и для формирования метапредметных умений, связанных с пониманием текста.</p>
                                    <br><p>Какие же эффективные приёмы обучения современным нормам построения предложения с деепричастным оборотом можно использовать на уроках русского языка? Обратимся к теории.</p>
                                    </div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Голуб И.Б. Новый справочник по русскому языку и практической стилистике. Учебное пособие / И.Б. Голуб. – Москва: Эксмо, 2007.",
                "Граник Г.Г. , Бондаренко С.М. Секреты пунктуации. – Москва: Просвещение, 1986",
                "Кохтев Н. Н., Розенталь Д. Э. Популярная стилистика русского языка. – Москва: Русский язык, 1984",
                "Львов М.Р. Словарь-справочник по методике русского языка: учеб. пособие для студентов пед. ин-тов. – Москва: Просвещение, 1988",
                "Львова С.И. Схема на уроке русского языка // Русский язык в школе. – 1990 – №2",
                "Морковкин В.В., Богачёва Г.Ф., Луцкая Н.М. Большой универсальный словарь русского языка / Гос. Ин-т рус. Яз. Им. А.С. Пушкина; Под ред. В.В. Морковкина. – Москва: Словари XXI века; АСТ-ПРЕСС ШКОЛА, 2016",
                "Норман Б.Ю.  Русский язык в задачах и ответах: сб. задач / Б.Ю. Норман. – Москва: Флинта: Наука, 2011",
                "Обучение русскому языку в школе: учебное пособие для студентов педагогических вузов / [Быстрова Е. А., Разумовская М.М., Львова С.И., Капинос В.И., Гостева Ю.Н., Цыбулько И.П. и др.]; под ред. Е. А. Быстровой. – 2-е изд., стер. – Москва: Дрофа, 2007",
                "Панова Г.И. Морфология русского языка: Энциклопедический словарь-справочник. – Москва: КомКнига, 2010",
                "Правила русской орфографии и пунктуации. Полный академический справочник / Под ред. В.В. Лопатина. – Москва: Эксмо, 2009",
                "Соколова О.И., Федюнина С.М., Шабанова Н.А. Культура речевой коммуникации. – Москва: Флинта, 2013",
                "Текучёв А.В. Методика русского языка в средней школе: учебник для студентов пед. ин-тов. – Изд. 3-е, перераб. – Москва: Просвещение, 1980",
                "Тихонов А.Н. Словообразовательный словарь русского языка. – Москва,1985",
                "Успенский М.Б. Задачи по русскому языку. Поиск и анализ трудных решений: учебное пособие. – Москва: Флинта, 2012 ",
            ],
            filesToDownload: [
                {
                    link: "./files/material1.pdf",
                    fileName: "Задания (часть 1)"
                },
                {
                    link: "./files/material2.pdf",
                    fileName: "Задания (часть 2)"
                },
                {
                    link: "./files/material3.pdf",
                    fileName: "Игры"
                },
                {
                    link: "./files/material4.pdf",
                    fileName: "Конструирование и исследование"
                },
                {
                    link: "./files/material5.pdf",
                    fileName: "Примеры заданий на проведение синтаксического и пунктуационного анализа"
                }
            ]
        }
    ],
};